/**
 * Shared styling tokens for the customer Services / Aliases panels (and the
 * controls inside them). Kept in one place so the two panels — which render in
 * both the wide customer-detail card and the narrow New Ticket sidebar — stay
 * consistent. See the sm4rt-web-ui skill §2 (density tiers) and §9 (buttons).
 */

/**
 * Density tier for a panel. `comfortable` is the wide customer-detail card;
 * `compact` (the default) is the narrow New Ticket customer sidebar.
 */
export type PanelDensity = 'comfortable' | 'compact';

/** Compact secondary/outlined button — accent text, hairline border, soft
 *  accent hover (design-system §9). Used for the panels' Add actions. */
export const SECONDARY_BTN_SX = {
  fontSize: 13,
  fontWeight: 500,
  py: 0.25,
  px: 1.25,
  minHeight: 0,
  textTransform: 'none',
  color: '#4A90D9',
  borderColor: '#c8d4e0',
  '&:hover': { borderColor: '#4A90D9', bgcolor: '#EDF5FF' },
  '& .MuiButton-startIcon': { mr: 0.5 },
} as const;
